module.exports = __webpack_public_path__ + "static/media/add-24px.e136cdd8.svg";